module.exports = __webpack_public_path__ + "img/62.1c1c9ff5.jpeg";